import {
	CombineProductionCatalogsMutation,
	CreateProductionCatalogMutation,
	RevertProductionCatalogCombineMutation,
	UpdateProductionCatalogMutation
} from "~/gql/mutations/produce/productionCatalog.generated";
import {
	AddProductionMaterialEventToCategoryMutation,
	AddProductionSpaceEventToCategoryMutation,
	AddProductionTaskEventToCategoryMutation,
	MergeProductionCategoryMutation,
	RemoveProductionMaterialEventFromCategoryMutation,
	RemoveProductionSpaceEventFromCategoryMutation,
	RemoveProductionTaskEventFromCategoryMutation,
	SetCategoryLaborCostMutation,
	SetCategoryUnitsPerPoleMutation
} from "~/gql/mutations/produce/productionCategory.generated";
import {
	ClearItemLaborCostMutation,
	CombineProductionItemsMutation,
	CreateProductionItemMutation,
	LinkProductionItemsToSalesItemMutation,
	RevertProductionItemCombineMutation,
	SetItemLaborCostMutation,
	UnlinkProductionItemsFromSalesItemMutation,
	UpdateProductionItemMutation
} from "~/gql/mutations/produce/productionItem.generated";
import {
	GetProductionCatalogCombinePreviewQuery,
	GetProductionCatalogsQuery
} from "~/gql/queries/produce/productionCatalog.generated";
import {
	GetProductionCategoriesQuery,
	GetProductionCategoryQuery
} from "~/gql/queries/produce/productionCategory.generated";
import {
	GetProductionItemCombinePreviewQuery,
	GetProductionItemsQuery
} from "~/gql/queries/produce/productionItem.generated";
import {
	GetProductionItemOrderLinesByShipWeekQuery,
	GetProductionItemOrdersByShipWeekQuery
} from "~/gql/queries/produce/productionItemOrders.generated";

export const productionItemEndpoints = {
	AddProductionMaterialEventToCategory: {
		invalidatesTags: ["ProductionCategories"] as AddTagTypes,
		transformResponse: (res: AddProductionMaterialEventToCategoryMutation) => res
	},
	AddProductionSpaceEventToCategory: {
		invalidatesTags: ["ProductionCategories"] as AddTagTypes,
		transformResponse: (res: AddProductionSpaceEventToCategoryMutation) => res
	},
	AddProductionTaskEventToCategory: {
		invalidatesTags: ["ProductionCategories"] as AddTagTypes,
		transformResponse: (res: AddProductionTaskEventToCategoryMutation) => res
	},
	CombineProductionCatalogs: {
		invalidatesTags: [
			"ProductionCatalogs",
			"ProductionItems",
			"ProductionJobs",
			"ProductionLots",
			"ProductionRecipe"
		] as AddTagTypes,
		transformResponse: (res: CombineProductionCatalogsMutation) => res
	},
	ClearItemLaborCost: {
		invalidatesTags: ["ProductionItems"] as AddTagTypes,
		transformResponse: (res: ClearItemLaborCostMutation) => res
	},
	CombineProductionItems: {
		invalidatesTags: ["ProductionItems"] as AddTagTypes,
		transformResponse: (res: CombineProductionItemsMutation) => res
	},
	CreateProductionCatalog: {
		invalidatesTags: ["ProductionCatalogs"] as AddTagTypes,
		transformResponse: (res: CreateProductionCatalogMutation) => res
	},
	CreateProductionItem: {
		invalidatesTags: ["ProductionItems"] as AddTagTypes,
		transformResponse: (res: CreateProductionItemMutation) => res
	},
	GetProductionCatalogCombinePreview: {
		providesTags: ["ProductionCatalogs"] as AddTagTypes,
		transformResponse: (res: GetProductionCatalogCombinePreviewQuery) => res
	},
	GetProductionCatalogs: {
		providesTags: ["ProductionCatalogs"] as AddTagTypes,
		transformResponse: (res: GetProductionCatalogsQuery) => res
	},
	GetProductionCategories: {
		providesTags: ["ProductionCategories"] as AddTagTypes,
		transformResponse: (res: GetProductionCategoriesQuery) => res
	},
	GetProductionCategory: {
		providesTags: ["ProductionCategories"] as AddTagTypes,
		transformResponse: (res: GetProductionCategoryQuery) => res
	},
	GetProductionItemCombinePreview: {
		providesTags: ["ProductionItems"] as AddTagTypes,
		transformResponse: (res: GetProductionItemCombinePreviewQuery) => res
	},
	GetProductionItemOrderLinesByShipWeek: {
		providesTags: ["Orders"] as AddTagTypes,
		transformResponse: (res: GetProductionItemOrderLinesByShipWeekQuery) => res
	},
	GetProductionItemOrdersByShipWeek: {
		providesTags: ["Orders"] as AddTagTypes,
		transformResponse: (res: GetProductionItemOrdersByShipWeekQuery) => res
	},
	GetProductionItems: {
		providesTags: ["ProductionItems"] as AddTagTypes,
		transformResponse: (res: GetProductionItemsQuery) => res
	},
	LinkProductionItemsToSalesItem: {
		invalidatesTags: ["ProductionItems"] as AddTagTypes,
		transformResponse: (res: LinkProductionItemsToSalesItemMutation) => res
	},
	MergeProductionCategory: {
		invalidatesTags: ["ProductionCategories"] as AddTagTypes,
		transformResponse: (res: MergeProductionCategoryMutation) => res
	},
	RemoveProductionMaterialEventFromCategory: {
		invalidatesTags: ["ProductionCategories"] as AddTagTypes,
		transformResponse: (res: RemoveProductionMaterialEventFromCategoryMutation) => res
	},
	RemoveProductionSpaceEventFromCategory: {
		invalidatesTags: ["ProductionCategories"] as AddTagTypes,
		transformResponse: (res: RemoveProductionSpaceEventFromCategoryMutation) => res
	},
	RemoveProductionTaskEventFromCategory: {
		invalidatesTags: ["ProductionCategories"] as AddTagTypes,
		transformResponse: (res: RemoveProductionTaskEventFromCategoryMutation) => res
	},
	RevertProductionCatalogCombine: {
		invalidatesTags: [
			"ProductionCatalogs",
			"ProductionItems",
			"ProductionJobs",
			"ProductionLots",
			"ProductionRecipe"
		] as AddTagTypes,
		transformResponse: (res: RevertProductionCatalogCombineMutation) => res
	},
	RevertProductionItemCombine: {
		invalidatesTags: ["ProductionItems"] as AddTagTypes,
		transformResponse: (res: RevertProductionItemCombineMutation) => res
	},
	SetCategoryLaborCost: {
		invalidatesTags: ["ProductionCategories"] as AddTagTypes,
		transformResponse: (res: SetCategoryLaborCostMutation) => res
	},
	SetCategoryUnitsPerPole: {
		invalidatesTags: ["ProductionCategories"] as AddTagTypes,
		transformResponse: (res: SetCategoryUnitsPerPoleMutation) => res
	},
	SetItemLaborCost: {
		invalidatesTags: ["ProductionItems"] as AddTagTypes,
		transformResponse: (res: SetItemLaborCostMutation) => res
	},
	UnlinkProductionItemsFromSalesItem: {
		invalidatesTags: ["ProductionItems"] as AddTagTypes,
		transformResponse: (res: UnlinkProductionItemsFromSalesItemMutation) => res
	},
	UpdateProductionCatalog: {
		invalidatesTags: ["ProductionCatalogs"] as AddTagTypes,
		transformResponse: (res: UpdateProductionCatalogMutation) => res
	},
	UpdateProductionItem: {
		invalidatesTags: ["ProductionItems"] as AddTagTypes,
		transformResponse: (res: UpdateProductionItemMutation) => res
	}
};
